<template>
  <div class="containerFull_universiade">
    <CompreSportsMeetCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></CompreSportsMeetCommon>
  </div>
</template>

<script>
// 大运会 容器
import CompreSportsMeetCommon from './compreSportsMeet_common'
import containerFull_data from '@mixins/compreSportsMeet/WUSG/containerFull_data'
export default {
  name: 'containerFull_universiade',
  mixins: [containerFull_data],
  components: {
    CompreSportsMeetCommon,
  },
}
</script>
